// extracted by mini-css-extract-plugin
export default {"container":"InformationSecurityPolicyPage_container__nhIGQ"};